import { createAction } from '@reduxjs/toolkit'

import { stateName } from './constants'

export const fetchBusinessAddresses = createAction(`${stateName}/fetchBusinessAddresses`)
